// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + "af5b322cd4768c2c4a78dac727040ec5" + ".css";
};